export default "__VITE_ASSET__B3_QEzk5__"